import {
    NewDataCollectionImportModalTextResponse,
    PortalTextBorrowerAnonymousSubmission,
    PortalTextLogin,
    PortalTextResponse,
    PortalTextSectionIds,
    PortalTextTimeoutMessaging,
} from '../../Models/Api/strongbox.financialportal';

export enum PortalAssetsActions {
    PortalAssetsInitialize = 'PORTALASSETS/INITIALIZE',
    PortalAssetsRetrieveLoginText = 'PORTALASSETS/RETRIEVE_LOGIN_TEXT',
    PortalAssetsRetrieveLoginTextCompleted = 'PORTALASSETS/RETRIEVE_LOGIN_TEXT_COMPLETED',
    PortalAssetsRetrieveTimeoutText = 'PORTALASSETS/RETRIEVE_TIMEOUT_TEXT',
    PortalAssetsRetrieveTimeoutTextCompleted = 'PORTALASSETS/RETRIEVE_TIMEOUT_TEXT_COMPLETED',
    PortalAssetsRetrieveBorrowerAnonymousText = 'PORTALASSETS/RETRIEVE_BORROWER_ANONYMOUS_TEXT',
    PortalAssetsRetrieveBorrowerAnonymousTextCompleted = 'PORTALASSETS/RETRIEVE_BORROWER_ANONYMOUS_TEXT_COMPLETED',
    PortalAssetsRetrieveText = 'PORTASSETS/RETRIEVE_TEXT',
    PortalAssetsRetrieveTextCompleted = 'PORTASSETS/RETRIEVE_TEXT_COMPLETED',
    PortalAssetsSetLanguageCode = 'PORTALASSETS/SET_LANGUAGE_CODE',
    PortalAssetsRetrieveAccountingSystemsText = 'PORTALASSETS/RETRIEVE_ACCOUNTING_SYSTEMS_TEXT',
    PortalAssetsRetrieveAccountingSystemsTextCompleted = 'PORTALASSETS/RETRIEVE_ACCOUNTING_SYSTEMS_TEXT_COMPLETED',
}

export interface IPortalAssetsInitialize {
    type: PortalAssetsActions.PortalAssetsInitialize;
    supportMultipleLanguages: boolean;
}

export interface IPortalAssetsRetrieveLoginText {
    type: PortalAssetsActions.PortalAssetsRetrieveLoginText;
}

export interface IPortalAssetsRetrieveTextLoginCompleted {
    type: PortalAssetsActions.PortalAssetsRetrieveLoginTextCompleted;
    portalLoginText?: PortalTextLogin;
}

export interface IPortalAssetsRetrieveTimeoutText {
    type: PortalAssetsActions.PortalAssetsRetrieveTimeoutText;
}

export interface IPortalAssetsRetrieveTimeoutTextCompleted {
    type: PortalAssetsActions.PortalAssetsRetrieveTimeoutTextCompleted;
    portalTimeoutText?: PortalTextTimeoutMessaging;
}

export interface IPortalAssetsRetrieveBorrowerAnonymousText {
    type: PortalAssetsActions.PortalAssetsRetrieveBorrowerAnonymousText;
}

export interface IPortalAssetsRetrieveBorrowerAnonymousTextCompleted {
    type: PortalAssetsActions.PortalAssetsRetrieveBorrowerAnonymousTextCompleted;
    portalBorrowerAnonymousText?: PortalTextBorrowerAnonymousSubmission;
}

export interface IPortalAssetsRetrieveText {
    type: PortalAssetsActions.PortalAssetsRetrieveText;
    sectionIds: PortalTextSectionIds[];
}

export interface IPortalAssetsRetrieveTextCompleted {
    type: PortalAssetsActions.PortalAssetsRetrieveTextCompleted;
    portalTextResponse?: PortalTextResponse;
    sectionIds: PortalTextSectionIds[];
}

export interface IPortalAssetsSetLanguageCode {
    type: PortalAssetsActions.PortalAssetsSetLanguageCode;
    languageCode: string;
}

export interface IPortalAssetsRetrieveAccountingSystemsText {
    type: PortalAssetsActions.PortalAssetsRetrieveAccountingSystemsText;
}

export interface IPortalAssetsRetrieveAccountingSystemsTextCompleted {
    type: PortalAssetsActions.PortalAssetsRetrieveAccountingSystemsTextCompleted;
    portalAccountingSystemsText?: NewDataCollectionImportModalTextResponse;
}


export type KnownAction =
    IPortalAssetsInitialize |
    IPortalAssetsRetrieveLoginText |
    IPortalAssetsRetrieveTextLoginCompleted |
    IPortalAssetsRetrieveText |
    IPortalAssetsRetrieveTextCompleted |
    IPortalAssetsRetrieveTimeoutText |
    IPortalAssetsRetrieveTimeoutTextCompleted |
    IPortalAssetsRetrieveBorrowerAnonymousText |
    IPortalAssetsRetrieveBorrowerAnonymousTextCompleted |
    IPortalAssetsSetLanguageCode |
    IPortalAssetsRetrieveAccountingSystemsText |
    IPortalAssetsRetrieveAccountingSystemsTextCompleted;
